export var units = {
    cup: { fractional: true },
    cups: { fractional: true },
    c: { fractional: true },
    'c.': { fractional: true },
    g: { withoutSpace: true },
    grms: {},
    kg: { withoutSpace: true },
    l: { withoutSpace: true },
    lb: {},
    lbs: {},
    liter: {},
    mg: { withoutSpace: true },
    ml: { withoutSpace: true },
    ounce: {},
    ounces: {},
    oz: {},
    pint: {},
    pints: {},
    pound: {},
    pounds: {},
    qt: {},
    t: { fractional: true },
    tablespoon: { fractional: true },
    tablespoons: { fractional: true },
    tbls: {},
    tbs: { capitalizable: true, fractional: true },
    tbsp: { capitalizable: true, fractional: true },
    teaspoon: { fractional: true },
    teaspoons: { fractional: true },
    tsp: { fractional: true },
    bottle: {},
    bottles: {},
};
export var isFractionalUnit = function (unit) { var _a; return ((_a = units[unit]) === null || _a === void 0 ? void 0 : _a.fractional) === true; };
export var isCapitalizableUnit = function (unit) { var _a; return ((_a = units[unit]) === null || _a === void 0 ? void 0 : _a.capitalizable) === true; };
export var isWithoutSpaceUnit = function (unit) { var _a; return ((_a = units[unit]) === null || _a === void 0 ? void 0 : _a.withoutSpace) === true; };
//# sourceMappingURL=units.js.map